import axiosInstance from "./api";

const TWILIO_SENDER_API = "/api/twilio";

export const createSender = async ({
  sender_name,
  brand_sid,
  messaging_service_sid,
  customer_profile_sid,
  rcs_sender_id,
  phone_number_sid,
  phone_number,
}) => {
  try {
    const result = await axiosInstance.post(`${TWILIO_SENDER_API}/sender`, {
      sender_name,
      brand_sid,
      messaging_service_sid,
      customer_profile_sid,
      rcs_sender_id,
      phone_number_sid,
      phone_number,
    });
    if (result.status !== 200 && result.status !== 201) {
      console.error("There was an error creating the sender.");
      throw new Error(
        result.data?.error || "There was an error creating the sender.",
      );
    }
    return result.data.data;
  } catch (error) {
    console.error("There was an error creating the sender:", error);
    throw new Error(
      error.response?.data?.error || "There was an error creating the sender.",
    );
  }
};

export const createMessagingService = async ({ friendly_name }) => {
  try {
    const result = await axiosInstance.post(
      `${TWILIO_SENDER_API}/messaging_service`,
      {
        friendly_name,
      },
    );
    if (result.status !== 200 && result.status !== 201) {
      console.error("There was an error creating the messaging service.");
      throw new Error(
        result.data?.error ||
          "There was an error creating the messaging service.",
      );
    }
    return result.data.data;
  } catch (error) {
    console.error("There was an error creating the messaging service:", error);
    throw new Error(
      error.response?.data?.error ||
        "There was an error creating the messaging service.",
    );
  }
};

export const getCustomerProfiles = async () => {
  const result = await axiosInstance.get(
    `${TWILIO_SENDER_API}/customer_profiles`,
  );
  return result?.data.data || [];
};

export const getTwilioSenders = async () => {
  const result = await axiosInstance.get(`${TWILIO_SENDER_API}/sender`);
  return result?.data.data || [];
};

export const getBrands = async () => {
  const result = await axiosInstance.get(`${TWILIO_SENDER_API}/brand`);
  return result?.data.data || [];
};

export const getMessagingServices = async () => {
  const result = await axiosInstance.get(
    `${TWILIO_SENDER_API}/messaging_service`,
  );
  return result?.data.data || [];
};

export const updateSenderStatus = async ({ twilio_sender_id }) => {
  try {
    const result = await axiosInstance.put(
      `${TWILIO_SENDER_API}/sender/${twilio_sender_id}/status`,
    );
    if (result.status !== 200 && result.status !== 201) {
      console.error("There was an error updating the sender status.");
      throw new Error(
        result.data?.error || "There was an error updating the sender status.",
      );
    }
    return result.data.data;
  } catch (error) {
    console.error("There was an error updating the sender status:", error);
    throw new Error(
      error.response?.data?.error ||
        "There was an error updating the sender status.",
    );
  }
};

export const refreshAllSenderStatuses = async () => {
  try {
    const result = await axiosInstance.get(
      `${TWILIO_SENDER_API}/sender/refresh`,
    );
    if (result.status !== 200 && result.status !== 201) {
      console.error("There was an error refreshing sender statuses.");
      throw new Error(
        result.data?.error || "There was an error refreshing sender statuses.",
      );
    }
    return result.data.data;
  } catch (error) {
    console.error("There was an error refreshing sender statuses:", error);
    throw new Error(
      error.response?.data?.error ||
        "There was an error refreshing sender statuses.",
    );
  }
};

export const twilioSenderService = {
  createSender,
  createMessagingService,
  getCustomerProfiles,
  getTwilioSenders,
  getBrands,
  getMessagingServices,
  updateSenderStatus,
  refreshAllSenderStatuses,
};

export default twilioSenderService;
